import * as Headless from "@headlessui/react";
import React, { forwardRef } from "react";
import { Link as UpstreamLink } from "react-router-dom";

export const Link = forwardRef(function Link(
    props: { href: string } & React.ComponentPropsWithoutRef<"a">,
    ref: React.ForwardedRef<HTMLAnchorElement>,
) {
    const { href, ...rest } = props;
    const isExternal = href.startsWith("http://") || href.startsWith("https://");

    if (isExternal) {
        return (
            <Headless.DataInteractive>
                <a href={href} {...rest} ref={ref} />
            </Headless.DataInteractive>
        );
    }

    return (
        <Headless.DataInteractive>
            <UpstreamLink to={href} {...rest} ref={ref} />
        </Headless.DataInteractive>
    );
});
